import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  model,
  output,
  ViewEncapsulation,
} from '@angular/core';

import { BspkTxt } from '@bspk/ngx-ui';
import { BspkIcon } from '../icon/icon.component';

/**
 * __note:__ This is only an implementation of the `input chip` variant
 * in the bespoke design system.
 */
@Component({
  selector: 'bspk-chip',
  imports: [BspkIcon, BspkTxt],
  templateUrl: './chip.component.html',
  styleUrl: './chip.component.scss',
  host: {
    'data-bspk': 'chip',
    '[attr.data-selected]': 'selected() || null',
    '[attr.aria-disabled]': 'disabled() ? "true" : null',
    '[tabindex]': 'disabled() ? -1 : 0',
  },
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BspkChip {
  readonly selected = model(false);
  readonly label = input.required<string>();
  readonly icon = input<string>();
  readonly removable = input(false, { transform: booleanAttribute });
  readonly disabled = input(false, { transform: booleanAttribute });

  readonly removed = output();
}
